class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.getCleanData = this.getCleanData.bind(this);
    this.getItemFromPath = this.getItemFromPath.bind(this);
    this.camelCaseToDash = this.camelCaseToDash.bind(this);
    this.getMenuFromObject = this.getMenuFromObject.bind(this);
  }

  getCleanData() {
    const data = this.props.data;
    let mixins, elements, components;

    mixins = data.children[0].children.map(el => {
      let path = el.path;
      return this.getItemFromPath(path);
    });

    elements = data.children[1].children.map(el => {
      let path = el.path;
      return this.getItemFromPath(path);
    });

    components = data.children[2].children.map(el => {
      let path = el.path;
      return this.getItemFromPath(path);
    });

    return {mixins, elements, components};

  }

  getItemFromPath(path) {
    let pathItems = path.split('/');
    return pathItems[pathItems.length - 1].split('.')[0].replace('Demo', '');
  }

  camelCaseToDash(myStr) {
    return myStr.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
  }

  getMenuFromObject(title, data) {
    return (
      <li>
        <a href={`#${title.toLowerCase()}`}>{title}</a>
        <ul>
          {
            data.map(mixin => {
              return (
                <li>
                <a href={`#${this.camelCaseToDash(mixin)}`}>{mixin}</a>
                </li>
              );
            })
          }
        </ul>
      </li>
    );
  }

  render () {
    const data = this.getCleanData();

    const mixins = this.getMenuFromObject('Mixins', data.mixins);
    const elements = this.getMenuFromObject('Elements', data.elements);
    const components = this.getMenuFromObject('Components', data.components);

    return(
      <div className="menu-wrapper">
        <svg id="logo" viewBox="0 0 1000 1000" shape-rendering="geometricPrecision"><path stroke="none" fill="inherit" d="M22.086288,271.695971 C79.6860102,238.891965 144.97997,201.712665 269.922119,201.712665 C394.785755,201.712665 460.079715,238.891965 517.679437,271.695971 C572.345642,302.665636 624.035504,331.965123 729.278119,331.965123 C834.535009,331.965123 886.139221,302.644223 940.776876,271.596046 C958.385118,261.603529 980.768356,267.763202 990.775148,285.357169 C1000.76766,302.972549 994.607992,325.348649 977.014025,335.355441 C919.30724,368.138034 853.906217,405.295921 729.278119,405.295921 C604.707121,405.295921 539.220448,368.195134 481.456563,335.448228 C426.868871,304.364364 375.378859,275.043464 269.922119,275.043464 C164.386866,275.043464 112.896854,304.364364 58.3733992,335.412541 C40.8008446,345.440745 18.3890567,339.295347 8.37512732,321.70138 C-1.63880208,304.093138 4.49945828,281.717038 22.086288,271.695971 L22.086288,271.695971 Z M977.0283,728.304029 C919.39289,761.12231 854.063242,798.287335 729.285257,798.287335 C604.657159,798.287335 539.206173,761.165135 481.456563,728.396817 C426.754671,697.348639 375.093359,668.034877 269.929256,668.034877 C164.522478,668.034877 112.953954,697.348639 58.3519867,728.396817 C40.7151944,738.367921 18.3605067,732.243936 8.36798981,714.635694 C-1.63880208,697.048864 4.5137333,674.658489 22.1219755,664.637422 C79.7716603,631.876241 145.129858,594.704079 269.929256,594.704079 C394.464567,594.704079 459.908415,631.847691 517.650887,664.637422 C572.345642,695.664187 624.006954,724.956536 729.285257,724.956536 C834.656347,724.956536 886.196322,695.628499 940.776876,664.580322 C958.385118,654.51643 980.754081,660.733203 990.775148,678.29862 C1000.7748,695.913999 994.622267,718.304375 977.0283,728.304029 L977.0283,728.304029 Z"></path></svg>
        <h1>Gooey</h1>
        <ul className="menu-container">
          {mixins}
          {elements}
          {components}
        </ul>
      </div>
    );
  }
}
